/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package demo

import org.koin.dsl.module
import studio.oddpods.cauce.core.data.repository.UserDataRepository
import studio.oddpods.cauce.core.data.repository.UserLogoutManager
import studio.oddpods.cauce.core.data.repository.cauce.DashboardRepository
import studio.oddpods.cauce.core.data.repository.cauce.PatientRepository
import studio.oddpods.cauce.core.data.repository.cauce.PaymentRepository
import studio.oddpods.cauce.core.data.repository.cauce.ProfileRepository
import studio.oddpods.cauce.core.data.repository.cauce.ReminderRepository
import studio.oddpods.cauce.core.data.repository.cauce.SessionRepository
import studio.oddpods.cauce.core.data.repository.notification.NotificationSettingsRepository
import studio.oddpods.cauce.core.network.auth.AuthService

val demoModule = module {
    single<AuthService> { DemoAuthService() }
    single<UserDataRepository> { DemoUserDataRepository() }
    single<ProfileRepository> { DemoProfileRepository() }
    single<PatientRepository> { DemoPatientRepository() }
    single<SessionRepository> { DemoSessionRepository() }
    single<PaymentRepository> { DemoPaymentRepository() }
    single<DashboardRepository> { DemoDashboardRepository() }
    single<ReminderRepository> { DemoReminderRepository() }
    single<NotificationSettingsRepository> { DemoNotificationSettingsRepository() }
    single<UserLogoutManager> { DemoUserLogoutManager() }
}
